import { fetchLabDataByNameFallbacks, getLabRawValue } from "./labRecordUtils";

const buildField = ({
  field,
  label,
  order,
  candidates,
  updateName,
  normalRange,
}) => ({
  field,
  label,
  order,
  candidates,
  updateName: updateName || candidates?.[0] || field,
  normalRange,
});

export const URINE_FIELD_SPECS = [
  buildField({
    field: "urinalysis_color",
    label: "สีของปัสสาวะ",
    order: 1,
    candidates: ["urinalysiscolorresult", "urinalysiscolorresul", "urinalysis_color", "color"],
    updateName: "urinalysiscolorresult",
    normalRange: "Yellow",
  }),
  buildField({
    field: "urinalysis_clarity",
    label: "ความใส (Clarity)",
    order: 2,
    candidates: ["urinalysisclarityresult", "urinalysisclarity", "clarity"],
    updateName: "urinalysisclarityresult",
    normalRange: "Clear",
  }),
  buildField({
    field: "urinalysis_appearance",
    label: "ลักษณะปัสสาวะ (Appearance)",
    order: 3,
    candidates: ["urinalysisapperanceresult", "urinalysisapperancer", "urinalysis_appearance", "appearance"],
    updateName: "urinalysisapperanceresult",
    normalRange: "Clear",
  }),
  buildField({
    field: "urinalysis_ph",
    label: "ค่า pH",
    order: 4,
    candidates: ["urinalysisphresult", "urinalysis_ph", "ph"],
    updateName: "urinalysisphresult",
    normalRange: "4.5-8.0",
  }),
  buildField({
    field: "urinalysis_specific_gravity",
    label: "ความถ่วงจำเพาะ",
    order: 5,
    candidates: ["urinalysisspecificgravityresult", "urinalysisspecificgrresult", "urinalysisspecificgr", "urinalysis_specific_gravity"],
    updateName: "urinalysisspecificgravityresult",
    normalRange: "1.005-1.030",
  }),
  buildField({
    field: "urinalysis_protein",
    label: "โปรตีน (Protein)",
    order: 6,
    candidates: ["urinalysisproteinresult", "urinalysisproteinres", "urinalysis_protein", "protein"],
    updateName: "urinalysisproteinresult",
    normalRange: "Negative,Neg,Trace",
  }),
  buildField({
    field: "urinalysis_glucose",
    label: "น้ำตาล (Glucose)",
    order: 7,
    candidates: ["urinalysissugarresult", "urinalysissugarresul", "urinalysis_glucose", "urinalysisglucose"],
    updateName: "urinalysissugarresult",
    normalRange: "Negative,Neg",
  }),
  buildField({
    field: "urinalysis_ketone",
    label: "คีโตน (Ketone)",
    order: 8,
    candidates: ["urinalysisketoneresult", "urinalysisketoneresu", "urinalysis_ketone", "urinalysisketone"],
    updateName: "urinalysisketoneresult",
    normalRange: "Negative,Neg",
  }),
  buildField({
    field: "urinalysis_blood",
    label: "เลือด (Blood)",
    order: 9,
    candidates: ["urinalysisbloodresult", "urinalysisbloodresul", "urinalysis_blood", "urinalysisblood"],
    updateName: "urinalysisbloodresult",
    normalRange: "Negative,Neg",
  }),
  buildField({
    field: "urinalysis_leukocyte",
    label: "Leukocyte",
    order: 10,
    candidates: ["urinalysisleukocyteresult", "urinalysisleukocyte", "urine_leukocyte", "urinalysis_leukocyte", "urinalysisleukocyter"],
    updateName: "urinalysisleukocyteresult",
    normalRange: "Negative,Neg",
  }),
  buildField({
    field: "urinalysis_nitrite",
    label: "Nitrite",
    order: 11,
    candidates: ["urinalysisnitriteresult", "urinalysisnitriter", "urine_nitrite", "urinalysis_nitrite", "urinalysisnitrite"],
    updateName: "urinalysisnitriteresult",
    normalRange: "Negative,Neg",
  }),
  buildField({
    field: "urinalysis_bilirubin",
    label: "Bilirubin",
    order: 12,
    candidates: ["urinalysisbilirubinresult", "urinalysisbilirubinr", "urine_bilirubin", "urinalysis_bilirubin", "urinalysisbilirubin"],
    updateName: "urinalysisbilirubinresult",
    normalRange: "Negative,Neg",
  }),
  buildField({
    field: "urinalysis_urobilinogen",
    label: "Urobilinogen",
    order: 13,
    candidates: ["urinalysisurobilinogenresult", "urinalysisurobilino", "urine_urobilinogen", "urinalysis_urobilinogen", "urinalysisurobilinogen"],
    updateName: "urinalysisurobilinogenresult",
    normalRange: "0.2-1.0",
  }),
  buildField({
    field: "urinalysis_rbc",
    label: "เซลล์เม็ดเลือดแดง (RBC)",
    order: 14,
    candidates: ["urinalysisrbcresult", "urinalysis_rbc", "urinalysisrbc", "urine_rbc"],
    updateName: "urinalysisrbcresult",
    normalRange: "0-2",
  }),
  buildField({
    field: "urinalysis_wbc",
    label: "เซลล์เม็ดเลือดขาว (WBC)",
    order: 15,
    candidates: ["urinalysiswbcresult", "urinalysis_wbc", "urinalysiswbc", "urine_wbc"],
    updateName: "urinalysiswbcresult",
    normalRange: "0-5",
  }),
  buildField({
    field: "urinalysis_bacteria",
    label: "แบคทีเรีย",
    order: 16,
    candidates: ["urinalysisbactcellresult", "urinalysisbactcellre", "urinalysisbacteriaresult", "urinalysisbacteria", "bacteria", "urinalysis_bacteria"],
    updateName: "urinalysisbactcellresult",
    normalRange: "Negative,Neg,Not found,None",
  }),
  buildField({
    field: "urinalysis_epithelial",
    label: "เซลล์เยื่อผิว (Epithelial Cells)",
    order: 17,
    candidates: ["urinalysisepithelialcellresult", "urinalysisepithelialresult", "urinalysisepithelial", "urinalysis_epithelial", "epithelial", "epithelialcells"],
    updateName: "urinalysisepithelialcellresult",
    normalRange: "0-5",
  }),
  buildField({
    field: "urinalysis_nonsquamous_epithelial_cell",
    label: "Non-squamous epithelial cell",
    order: 18,
    candidates: ["urinalysisnonsquamousepithelialcellresult", "urinalysisnonsquamousepithelialcell", "nonsquamousepithelialcell"],
    updateName: "urinalysisnonsquamousepithelialcellresult",
    normalRange: "Negative,Neg,Not found,None",
  }),
  buildField({
    field: "urinalysis_renal_tubular_epithelial_cell",
    label: "Renal tubular epithelial cell",
    order: 19,
    candidates: ["urinalysisrenaltubularepithelialcellresult", "urinalysisrenaltubularepithelialcell", "renaltubularepithelialcell"],
    updateName: "urinalysisrenaltubularepithelialcellresult",
    normalRange: "Negative,Neg,Not found,None",
  }),
  buildField({
    field: "urinalysis_rbc_cast",
    label: "RBC cast",
    order: 20,
    candidates: ["urinalysisrbccastresult", "urinalysisrbccast", "rbccast", "rbc_cast"],
    updateName: "urinalysisrbccastresult",
    normalRange: "Negative,Neg,Not found,None",
  }),
  buildField({
    field: "urinalysis_hyaline_cast",
    label: "Hyaline cast",
    order: 21,
    candidates: ["urinalysishyalinecastresult", "urinalysishyalinecast", "urinalysishyalinecas", "hyalinecast"],
    updateName: "urinalysishyalinecastresult",
    normalRange: "Negative,Neg,Not found,None",
  }),
  buildField({
    field: "urinalysis_granular_cast",
    label: "Granular cast",
    order: 22,
    candidates: ["urinalysisgranularcastresult", "urinalysisgranularcast", "urinalysisgranularca", "granularcast"],
    updateName: "urinalysisgranularcastresult",
    normalRange: "Negative,Neg,Not found,None",
  }),
  buildField({
    field: "urinalysis_cellular_cast",
    label: "Cellular cast",
    order: 23,
    candidates: ["urinalysiscellularcastresult", "urinalysiscellularcast", "urinalysiscellularca", "cellularcast"],
    updateName: "urinalysiscellularcastresult",
    normalRange: "Negative,Neg,Not found,None",
  }),
  buildField({
    field: "urinalysis_waxy_cast",
    label: "Waxy cast",
    order: 24,
    candidates: ["urinalysiswaxycastresult", "urinalysiswaxycast", "urinalysiswaxycastno", "waxycast"],
    updateName: "urinalysiswaxycastresult",
    normalRange: "Negative,Neg,Not found,None",
  }),
  buildField({
    field: "urinalysis_crystal",
    label: "Crystal",
    order: 25,
    candidates: ["urinalysiscrystalresult", "urinalysiscrystal", "urinalysis_crystal", "crystal"],
    updateName: "urinalysiscrystalresult",
    normalRange: "Negative,Neg,Not found,None",
  }),
  buildField({
    field: "urinalysis_calcium_oxalate_crystal",
    label: "Calcium oxalate crystal",
    order: 26,
    candidates: ["urinalysiscalciumoxalatecrystalresult", "urinalysiscalciumoxalatecrystal", "urinalysiscalciumoxa", "calciumoxalatecrystal"],
    updateName: "urinalysiscalciumoxalatecrystalresult",
    normalRange: "Negative,Neg,Not found,None",
  }),
  buildField({
    field: "urinalysis_calcium_carbonate_crystal",
    label: "Calcium Carbonate crystal",
    order: 27,
    candidates: ["urinalysiscalciumcarbonatecrystalresult", "urinalysiscalciumcarbonatecrystal", "urinalysiscalciumcar", "urinalysiscalciumcarbonateresult", "urinalysiscalciumcarbonate", "calciumcarbonatecrystal"],
    updateName: "urinalysiscalciumcarbonatecrystalresult",
    normalRange: "Negative,Neg,Not found,None",
  }),
  buildField({
    field: "urinalysis_uric_acid_crystal",
    label: "Uric acid crystal",
    order: 28,
    candidates: ["urinalysisuricacidcrystalresult", "urinalysisuricacidcrystal", "urinalysisuricacidcr", "uricacidcrystal"],
    updateName: "urinalysisuricacidcrystalresult",
    normalRange: "Negative,Neg,Not found,None",
  }),
  buildField({
    field: "urinalysis_triple_phosphate_crystal",
    label: "Triple phosphate crystal",
    order: 29,
    candidates: ["urinalysistriplephosphatecrystalresult", "urinalysistriplephosphate", "urinalysistriplephos", "triplephosphatecrystal"],
    updateName: "urinalysistriplephosphatecrystalresult",
    normalRange: "Negative,Neg,Not found,None",
  }),
  buildField({
    field: "urinalysis_cystine_crystal",
    label: "Cystine crystal",
    order: 30,
    candidates: ["urinalysiscystinecrystalresult", "urinalysiscystinecrystal", "urinalysiscystinecryst", "cystinecrystal"],
    updateName: "urinalysiscystinecrystalresult",
    normalRange: "Negative,Neg,Not found,None",
  }),
  buildField({
    field: "urinalysis_calcium_phosphate_crystal",
    label: "Calcium phosphate crystal",
    order: 31,
    candidates: ["urinalysiscalciumphosphatecrystalresult", "urinalysiscalciumphosphatecrystal", "urinalysiscalciumphos", "urinalysiscalciumphosphate", "calciumphosphatecrystal"],
    updateName: "urinalysiscalciumphosphatecrystalresult",
    normalRange: "Negative,Neg,Not found,None",
  }),
  buildField({
    field: "urinalysis_yeast",
    label: "Yeast",
    order: 32,
    candidates: ["urinalysisyeastresult", "urinalysisyeast", "urinalysis_yeast", "yeast"],
    updateName: "urinalysisyeastresult",
    normalRange: "Negative,Neg,Not found,None",
  }),
  buildField({
    field: "urinalysis_mucus_thread",
    label: "Mucus",
    order: 33,
    candidates: ["urinalysismucusthreadresult", "urinalysismucusthread", "urinalysismucus", "mucusthread", "mucus", "mucous"],
    updateName: "urinalysismucusthreadresult",
    normalRange: "Negative,Neg,Not found,None",
  }),
  buildField({
    field: "urinalysis_others",
    label: "Others",
    order: 34,
    candidates: ["urinalysisothersresult", "urinalysisothers", "urinalysis others result", "urinalysis others", "others"],
    updateName: "urinalysisothersresult",
    normalRange: "Negative,Neg,Not found,None",
  }),
];

export const URINE_EDITABLE_FIELDS = URINE_FIELD_SPECS.map((item) => item.field);

export const URINE_LABEL_MAP = URINE_FIELD_SPECS.reduce((acc, item) => {
  acc[item.field] = item.label;
  return acc;
}, {});

export const URINE_DB_NAME_MAP = URINE_FIELD_SPECS.reduce((acc, item) => {
  acc[item.field] = item.updateName;
  return acc;
}, {});

export const URINE_FORMULA_RULES = URINE_FIELD_SPECS.reduce((acc, item) => {
  const formulaKeyMap = {
    urinalysis_color: "color",
    urinalysis_clarity: "clarity",
    urinalysis_appearance: "appearance",
    urinalysis_ph: "ph",
    urinalysis_specific_gravity: "specificGravity",
    urinalysis_protein: "protein",
    urinalysis_glucose: "glucose",
    urinalysis_ketone: "ketones",
    urinalysis_blood: "blood",
    urinalysis_leukocyte: "leukocytes",
    urinalysis_nitrite: "nitrite",
    urinalysis_bilirubin: "bilirubin",
    urinalysis_urobilinogen: "urobilinogen",
    urinalysis_rbc: "redBloodCells",
    urinalysis_wbc: "whiteBloodCells",
    urinalysis_bacteria: "bacteria",
    urinalysis_epithelial: "epithelialCells",
    urinalysis_nonsquamous_epithelial_cell: "nonsquamousEpithelialCell",
    urinalysis_renal_tubular_epithelial_cell: "renalTubularEpithelialCell",
    urinalysis_rbc_cast: "rbcCast",
    urinalysis_hyaline_cast: "hyalineCast",
    urinalysis_granular_cast: "granularCast",
    urinalysis_cellular_cast: "cellularCast",
    urinalysis_waxy_cast: "waxyCast",
    urinalysis_crystal: "crystal",
    urinalysis_calcium_oxalate_crystal: "calciumOxalateCrystal",
    urinalysis_calcium_carbonate_crystal: "calciumCarbonateCrystal",
    urinalysis_uric_acid_crystal: "uricAcidCrystal",
    urinalysis_triple_phosphate_crystal: "triplePhosphateCrystal",
    urinalysis_cystine_crystal: "cystineCrystal",
    urinalysis_calcium_phosphate_crystal: "calciumPhosphateCrystal",
    urinalysis_yeast: "yeast",
    urinalysis_mucus_thread: "mucusThread",
    urinalysis_others: "others",
  };

  const formulaKey = formulaKeyMap[item.field];
  if (formulaKey) {
    acc[formulaKey] = item.normalRange;
  }
  return acc;
}, {});

export const URINE_LABDATA_SOURCE_KEYS = {
  urinalysis_color: ["urinalysis_color", "urinalysiscolorresul", "urinalysiscolorresult", "color"],
  urinalysis_clarity: ["clarity", "urinalysisclarityresult", "urinalysisclarity"],
  urinalysis_appearance: ["urinalysis_appearance", "urinalysisapperancer", "urinalysisapperanceresult", "appearance"],
  urinalysis_ph: ["urinalysis_ph", "urinalysisphresult", "ph"],
  urinalysis_specific_gravity: ["urinalysis_specific_gravity", "urinalysisspecificgr", "urinalysisspecificgrresult", "urinalysisspecificgravityresult"],
  urinalysis_protein: ["urinalysis_protein", "urinalysisproteinres", "urinalysisproteinresult", "protein"],
  urinalysis_glucose: ["urinalysis_glucose", "urinalysissugarresul", "urinalysissugarresult", "urinalysisglucose"],
  urinalysis_ketone: ["urinalysis_ketone", "urinalysisketoneresu", "urinalysisketoneresult", "urinalysisketone"],
  urinalysis_blood: ["urinalysis_blood", "urinalysisbloodresul", "urinalysisbloodresult", "urinalysisblood"],
  urinalysis_leukocyte: ["urinalysis_leukocyte", "urinalysisleukocyteresult", "urinalysisleukocyter", "urine_leukocyte", "urineleukocyte"],
  urinalysis_nitrite: ["urinalysis_nitrite", "urinalysisnitriteresult", "urinalysisnitritere", "urine_nitrite", "urinenitrite"],
  urinalysis_bilirubin: ["urinalysis_bilirubin", "urinalysisbilirubinresult", "urinalysisbilirubinr", "urine_bilirubin", "urinebilirubin"],
  urinalysis_urobilinogen: ["urinalysis_urobilinogen", "urinalysisurobilinogenresult", "urinalysisurobilino", "urine_urobilinogen", "urineurobilinogen"],
  urinalysis_rbc: ["urinalysis_rbc", "urinalysisrbcresult", "urinalysisrbc", "urine_rbc", "urinerbc"],
  urinalysis_wbc: ["urinalysis_wbc", "urinalysiswbcresult", "urinalysiswbc", "urine_wbc", "urinewbc"],
  urinalysis_bacteria: ["bacteria", "urinalysis_bacteria", "urinalysisbactcellre", "urinalysisbactcellresult", "urinalysisbacteria"],
  urinalysis_epithelial: ["epithelial", "urinalysis_epithelial", "urinalysisepithelial", "urinalysisepithelialcellresult"],
  urinalysis_nonsquamous_epithelial_cell: ["nonsquamousepithelialcell", "urinalysisnonsquamousepithelialcell", "urinalysisnonsquamousepithelialcellresult"],
  urinalysis_renal_tubular_epithelial_cell: ["renaltubularepithelialcell", "urinalysisrenaltubularepithelialcell", "urinalysisrenaltubularepithelialcellresult"],
  urinalysis_rbc_cast: ["rbccast", "rbc_cast", "urinalysisrbccast", "urinalysisrbccastresult"],
  urinalysis_hyaline_cast: ["hyalinecast", "urinalysishyalinecast", "urinalysishyalinecastresult", "urinalysishyalinecas"],
  urinalysis_granular_cast: ["granularcast", "urinalysisgranularcast", "urinalysisgranularcastresult", "urinalysisgranularca"],
  urinalysis_cellular_cast: ["cellularcast", "urinalysiscellularcast", "urinalysiscellularcastresult", "urinalysiscellularca"],
  urinalysis_waxy_cast: ["waxycast", "urinalysiswaxycast", "urinalysiswaxycastresult", "urinalysiswaxycastno"],
  urinalysis_crystal: ["crystal", "urinalysiscrystal", "urinalysiscrystalresult", "urinalysis_crystal"],
  urinalysis_calcium_oxalate_crystal: ["calciumoxalatecrystal", "urinalysiscalciumoxalatecrystal", "urinalysiscalciumoxalatecrystalresult", "urinalysiscalciumoxa"],
  urinalysis_calcium_carbonate_crystal: ["calciumcarbonatecrystal", "urinalysiscalciumcarbonatecrystal", "urinalysiscalciumcarbonatecrystalresult", "urinalysiscalciumcar", "urinalysiscalciumcarbonateresult", "urinalysiscalciumcarbonate"],
  urinalysis_uric_acid_crystal: ["uricacidcrystal", "urinalysisuricacidcrystal", "urinalysisuricacidcrystalresult", "urinalysisuricacidcr"],
  urinalysis_triple_phosphate_crystal: ["triplephosphatecrystal", "urinalysistriplephosphate", "urinalysistriplephosphatecrystalresult", "urinalysistriplephos"],
  urinalysis_cystine_crystal: ["cystinecrystal", "urinalysiscystinecrystal", "urinalysiscystinecrystalresult", "urinalysiscystinecryst"],
  urinalysis_calcium_phosphate_crystal: ["calciumphosphatecrystal", "urinalysiscalciumphosphatecrystal", "urinalysiscalciumphosphatecrystalresult", "urinalysiscalciumphos", "urinalysiscalciumphosphate"],
  urinalysis_yeast: ["yeast", "urinalysisyeast", "urinalysisyeastresult", "urinalysis_yeast"],
  urinalysis_mucus_thread: ["mucus", "mucous", "mucusthread", "urinalysismucusthread", "urinalysismucusthreadresult", "urinalysismucus"],
  urinalysis_others: ["others", "urinalysisothers", "urinalysisothersresult", "urinalysis others", "urinalysis others result"],
};

export const buildUrineFormulaData = (raw = {}) => ({
  color: raw.urinalysis_color ?? raw.color ?? "",
  clarity: raw.urinalysis_clarity ?? raw.clarity ?? "",
  appearance: raw.urinalysis_appearance ?? raw.appearance ?? "",
  ph: raw.urinalysis_ph ?? raw.ph ?? "",
  specificGravity: raw.urinalysis_specific_gravity ?? raw.specificGravity ?? raw.specificgravity ?? "",
  protein: raw.urinalysis_protein ?? raw.protein ?? "",
  glucose: raw.urinalysis_glucose ?? raw.glucose ?? "",
  ketones: raw.urinalysis_ketone ?? raw.urinalysis_ketones ?? raw.ketones ?? "",
  blood: raw.urinalysis_blood ?? raw.blood ?? "",
  leukocytes: raw.urinalysis_leukocyte ?? raw.urinalysis_leukocytes ?? raw.leukocytes ?? "",
  nitrite: raw.urinalysis_nitrite ?? raw.nitrite ?? "",
  bilirubin: raw.urinalysis_bilirubin ?? raw.bilirubin ?? "",
  urobilinogen: raw.urinalysis_urobilinogen ?? raw.urobilinogen ?? "",
  redBloodCells: raw.urinalysis_rbc ?? raw.redBloodCells ?? raw.redbloodcells ?? "",
  whiteBloodCells: raw.urinalysis_wbc ?? raw.whiteBloodCells ?? raw.whitebloodcells ?? "",
  bacteria: raw.urinalysis_bacteria ?? raw.bacteria ?? "",
  epithelialCells: raw.urinalysis_epithelial ?? raw.epithelialCells ?? raw.epithelial ?? "",
  nonsquamousEpithelialCell: raw.urinalysis_nonsquamous_epithelial_cell ?? raw.nonsquamousEpithelialCell ?? "",
  renalTubularEpithelialCell: raw.urinalysis_renal_tubular_epithelial_cell ?? raw.renalTubularEpithelialCell ?? "",
  rbcCast: raw.urinalysis_rbc_cast ?? raw.rbcCast ?? "",
  hyalineCast: raw.urinalysis_hyaline_cast ?? raw.hyalineCast ?? "",
  granularCast: raw.urinalysis_granular_cast ?? raw.granularCast ?? "",
  cellularCast: raw.urinalysis_cellular_cast ?? raw.cellularCast ?? "",
  waxyCast: raw.urinalysis_waxy_cast ?? raw.waxyCast ?? "",
  crystal: raw.urinalysis_crystal ?? raw.crystal ?? "",
  calciumOxalateCrystal: raw.urinalysis_calcium_oxalate_crystal ?? raw.calciumOxalateCrystal ?? "",
  calciumCarbonateCrystal: raw.urinalysis_calcium_carbonate_crystal ?? raw.calciumCarbonateCrystal ?? "",
  uricAcidCrystal: raw.urinalysis_uric_acid_crystal ?? raw.uricAcidCrystal ?? "",
  triplePhosphateCrystal: raw.urinalysis_triple_phosphate_crystal ?? raw.triplePhosphateCrystal ?? "",
  cystineCrystal: raw.urinalysis_cystine_crystal ?? raw.cystineCrystal ?? "",
  calciumPhosphateCrystal: raw.urinalysis_calcium_phosphate_crystal ?? raw.calciumPhosphateCrystal ?? "",
  yeast: raw.urinalysis_yeast ?? raw.yeast ?? "",
  mucusThread: raw.urinalysis_mucus_thread ?? raw.mucusThread ?? "",
  others: raw.urinalysis_others ?? raw.others ?? "",
});

export const getUrineDisplayEntries = (raw = {}) => {
  return [...URINE_FIELD_SPECS]
    .sort((a, b) => a.order - b.order)
    .map((item) => ({
      field: item.field,
      label: item.label,
      value: [item.field, ...(URINE_LABDATA_SOURCE_KEYS[item.field] || [])]
        .map((key) => raw[key])
        .find((value) => value !== undefined && value !== null && String(value).trim() !== "") ?? "",
      order: item.order,
    }))
    .filter((item) => item.value !== "" && item.value !== null && item.value !== undefined);
};

export const getUrineUpdateName = (field) => URINE_DB_NAME_MAP[field] || field;

export const getUrineFieldFromLabItem = (item, field) => {
  const keys = [field, ...(URINE_LABDATA_SOURCE_KEYS[field] || [])];
  for (const key of keys) {
    const value = item?.[key];
    if (value !== undefined && value !== null && String(value).trim() !== "") {
      return String(value).trim();
    }
  }
  return "";
};

export const buildUrineResultsFromLabData = (labData = {}) => {
  const recordsMap = new Map();

  URINE_FIELD_SPECS.forEach((spec) => {
    const keys = URINE_LABDATA_SOURCE_KEYS[spec.field] || [spec.field];
    keys.forEach((key) => {
      const items = labData?.[key] || [];
      items.forEach((item) => {
        const value = String(item?.value ?? item?.result ?? item?.data ?? "").trim();
        const dateValue = String(item?.date ?? item?.dateadd ?? "").trim();
        const dateOnly = dateValue.split("T")[0].split(" ")[0];
        if (!value || !dateOnly) return;

        if (!recordsMap.has(dateOnly)) {
          recordsMap.set(dateOnly, {
            dateadd: item?.date || item?.dateadd || dateOnly,
            visit_date: dateOnly,
            hospital_name: "โรงพยาบาลมหาวิทยาลัยแม่ฟ้าหลวง",
          });
        }

        const record = recordsMap.get(dateOnly);
        record[spec.field] = value;
        if (!record.dateadd || new Date(item?.date || item?.dateadd || 0) > new Date(record.dateadd)) {
          record.dateadd = item?.date || item?.dateadd || record.dateadd;
        }
      });
    });
  });

  const list = Array.from(recordsMap.values()).sort((a, b) => new Date(b.dateadd) - new Date(a.dateadd));

  return {
    result: list.length > 0,
    list,
  };
};

const getUrineDateKey = (item) => {
  const rawDate = String(item?.dateadd ?? item?.date ?? item?.visit_date ?? "").trim();
  if (!rawDate) return "";
  return rawDate.split("T")[0].split(" ")[0];
};

export const getUrineTestResultsCombined = async (getLabDataByName) => {
  const fetches = await Promise.all(
    URINE_FIELD_SPECS.map((spec) =>
      fetchLabDataByNameFallbacks(getLabDataByName, spec.candidates).catch(() => []),
    ),
  );

  const recordsMap = new Map();

  URINE_FIELD_SPECS.forEach((spec, index) => {
    const items = fetches[index] || [];

    items.forEach((item) => {
      const dateKey = getUrineDateKey(item);
      if (!dateKey) return;

      if (!recordsMap.has(dateKey)) {
        recordsMap.set(dateKey, {
          dateadd: item.dateadd,
          visit_date: dateKey,
          hospital_name: item.hospital || "โรงพยาบาลมหาวิทยาลัยแม่ฟ้าหลวง",
        });
      }

      const record = recordsMap.get(dateKey);
      const value = getLabRawValue(item);
      if (value !== "") {
        record[spec.field] = value;
      }

      const itemDateTime = item?.dateadd ?? item?.date ?? item?.visit_date ?? "";
      if (!record.dateadd || new Date(itemDateTime) > new Date(record.dateadd)) {
        record.dateadd = itemDateTime;
      }
    });
  });

  const list = Array.from(recordsMap.values()).sort(
    (a, b) => new Date(b.dateadd) - new Date(a.dateadd),
  );

  return {
    result: list.length > 0,
    list,
  };
};
